import { useEffect, useState } from "react";
import { useTheme } from "styled-components";
import Typography from "../../../Typography";
import { Filters, Button, Label, ResetFilters } from "./styles";
import Icon from "../../../Icon";
import { useLayout } from "../../../../provider/LayoutProvider";
import Sidebar from "../../../Sidebar";
import FilterIcon from "../../../../assets/icons/icon-cool/outline/Filter.svg";
import CloseIcon from "../../../../assets/icons/icon-cool/outline/Close.svg";
import { connect } from "react-redux";
import Filter from "./components/Filter";

const Component = ({ statics, staticsStates }) => {
  const theme = useTheme() as { [key: string]: { [key: string]: string } };
  const { applyedFilters, resetFilters } = useLayout();
  const [visible, setVisible] = useState<boolean>(false);
  const { layout } = useLayout();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const sidebarWidth = windowWidth > 648 ? "calc(100vw - 75%)" : "calc(100vw - 20%)";

  if (!layout.showFilters) {
    return null;
  }

  return (
    <>
      <Button
        type="button"
        onClick={() => {
          setVisible((oldState) => !oldState);
        }}
      >
        <Icon icon={FilterIcon} size="16px" color={theme.colors.Black} />

        {Object.keys(applyedFilters).length > 0 && (
          <Label>{Object.keys(applyedFilters).length}</Label>
        )}
      </Button>

      <Sidebar
        position="right"
        visible={visible}
        onClose={() => {
          setVisible(false);
        }}
        width={sidebarWidth}
        title="Filtros"
      >
        <Filters>
            {
              Object.keys(applyedFilters).length > 0 ?
              <ResetFilters
                type="button"
                onClick={() => resetFilters()}
              >
                <Icon icon={CloseIcon} size="12px" color={theme.colors.Black}/>
                <span style={{marginLeft: 5}}>Quitar Filtros</span>
              </ResetFilters>
              :
                null
            }
          <Typography as="h4" size="sm">
            Navegar por caracter
          </Typography>
          {/* category=1,2 level=1,2 enrollment_requirement=Mandatory,Optional */}
          {statics?.enrollment_requirement?.map((filter, index) => {
            const filterName = "enrollment_requirement";
            const fieldName = filterName;
            const value = filter.text;
            const label = filter.spanish;
            return <Filter name={fieldName} value={value} label={label} key={index}/>;
          })}
        </Filters>

        <div style={{ height: 30 }} />

        <Filters>
          <Typography as="h4" size="sm">
            Navegar por categoría
          </Typography>

          {statics?.categories?.map((filter, index) => {
            const filterName = "category";
            const fieldName = filterName;
            const value = filter.id;
            const label = filter.category;
            return <Filter name={fieldName} value={value} label={label} key={index}/>;
          })}
        </Filters>

        <div style={{ height: 30 }} />

        <Filters>
          <Typography as="h4" size="sm">
            Navegar por nivel
          </Typography>

          {statics?.levels?.map((filter, index) => {
            const filterName = "level";
            const fieldName = filterName;
            const value = filter.id;
            const label = filter.level;
            return <Filter name={fieldName} value={value} label={label} key={index}/>;
          })}
        </Filters>
      </Sidebar>
    </>
  );
};

const state = ({ staticsStore }) => {
  const { data: statics, states: staticsStates } = staticsStore;

  return {
    statics,
    staticsStates,
  };
};

export default connect(state)(Component);
